import React, { Component } from 'react';
import axios from "axios";
import Loading from './Loading';

export default class Testimonials extends Component {

	constructor(props) {
		super(props);

		this.state = {
			professionals: [],
			loading: true,
		}
	}

	componentDidMount() {
		this.loadProfessionals();
	}

	componentDidUpdate(prevProps, prevState) {
		// Réinitialiser le carousel après le chargement des données
		if (prevState.loading && !this.state.loading && this.state.professionals.length > 0) {
			setTimeout(() => {
				if (window.jQuery && window.jQuery('.testi_slider').length) {
					// Détruire le carousel existant s'il existe
					const $slider = window.jQuery('.testi_slider');
					if ($slider.data('owl.carousel')) {
						$slider.trigger('destroy.owl.carousel');
					}
					// Réinitialiser le carousel avec les mêmes options que dans main.js
					$slider.owlCarousel({
						loop: true,
						margin: 30,
						items: 1,
						nav: true,
						autoplay: 2500,
						smartSpeed: 1500,
						dots: true,
						responsiveClass: true,
						navText: ["<i class='lnr lnr-arrow-left'> </i>","<i class='lnr lnr-arrow-right'> </i>"]
					});
				}
			}, 100);
		}
	}

	loadProfessionals = async () => {
		try {
			this.setState({ loading: true });

			const response = await axios.get('/api/professionals');

			if (response.data.success && response.data.professionals) {
				this.setState({
					professionals: response.data.professionals,
					loading: false
				});
			} else {
				this.setState({ loading: false });
			}
		} catch (error) {
			console.error("Error loading professionals:", error);
			this.setState({ loading: false });
		}
	}

	render() {
		const { professionals, loading } = this.state;

		return (
			<>
				{/* Start Testimonials Area */}
				<section className="testimonials_area section-gap">
					<div className="container">
						<div className="row d-flex justify-content-between align-items-end">
							<div className="col-lg-12">
								<div className="section-title">
									<h2>Parcours Professionnels</h2>
								</div>
							</div>
						</div>

						{loading ? (
							<div className="row">
								<div className="col-12">
									<Loading variant="dots" size="medium" color="primary" text="Chargement du parcours professionnel..." />
								</div>
							</div>
						) : professionals.length === 0 ? (
							<div className="row">
								<div className="col-12 text-center">
									<p>Aucun parcours professionnel disponible</p>
								</div>
							</div>
						) : (
							<div className="testi_slider owl-carousel">
								{
									professionals.map((professional, key) => {
										// Construire le titre avec le titre et l'entreprise si disponible
										const title = professional.company 
											? `${professional.title} (${professional.company})`
											: professional.title;

										return (
											<div className="item" key={professional.id || key}>
												<div className="testi_item">
													<img src={ require("./../../img/quote.png") } alt="" />
													<h4>{ title }</h4>
													<div className="wow fadeIn" data-wow-duration="1s">
														<p>
															{ professional.description || 'Parcours professionnel.' }
														</p>
													</div>
												</div>
											</div>
										);
									})
								}
							</div>
						)}
					</div>
				</section>
				{/* End Testimonials Area */}
			</>
		);
	}

}